import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { APP_ENV } from './constants.ts';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const focusRing = [
    // base
    'outline-solid outline-offset-2 outline-0 focus-visible:outline-2',
    // outline color
    'outline-blue-500',
];

// Lang

export const isDev = () => process.env.NODE_ENV === 'development' || APP_ENV !== 'production';

const UUUID_REGEX = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}/i;

export const validateUUID = (uuid: unknown) => {
    return typeof uuid === 'string' && UUUID_REGEX.test(uuid);
};
